export default "__VITE_ASSET__DfVFejHZ__"